import _ from 'underscore';

export const CURRENCY = {
  ars: 'ArgentinePeso',
  aud: 'AustralianDollar',
  brl: 'BrazilianReal',
  cad: 'CanadianDollar',
  chf: 'SwissFranc',
  clp: 'ChileanPeso',
  cny: 'YuanRenminbi',
  cop: 'ColombianPeso',
  dkk: 'DanishKrone',
  dzd: 'AlgerianDinar',
  egp: 'EgyptianPound',
  eur: 'Euro',
  gbp: 'UKPound',
  hkd: 'HongKongDollar',
  idr: 'IndonesianRupiah',
  inr: 'IndianRupee',
  jpy: 'JapaneseYen',
  lbp: 'LebanesePound',
  mad: 'MoroccanDirham',
  mxn: 'MexicanPeso',
  myr: 'MalaysianRingit',
  ngn: 'NigerianNaira',
  nok: 'NorwegianKrone',
  nzd: 'NewZealandDollar',
  pen: 'PeruvianNuevoSol',
  php: 'PhilippinePeso',
  pln: 'PolishZloty',
  qar: 'QatariRiyal',
  sar: 'SaudiRiyal',
  sek: 'SwedishKrona',
  sgd: 'SingaporeDollar',
  thb: 'ThaiBaht',
  try: 'TurkishLira',
  twd: 'NewTaiwanDollar',
  usd: 'UsDollar',
  vef: 'VenezuelanBolivar',
  vnd: 'VietnamDong',
  zar: 'SouthAfricanRand',
};

export const formatBudgetSuggestionPayload = ({
  currency,
  targets,
  website,
  language,
  budget,
}) => ({
  website,
  targets,
  language,
  budget,
  currency: (currency && _.get(CURRENCY, currency.toLowerCase())) || (currency && currency.toLowerCase()),
});
